/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Flex, Pane, Button, Label, PortalOverlay } from '@leverege/ui-elements'
import { GlobalState, UI } from '@leverege/ui-redux'

import CameraScreen from './CameraScreen.jsx'
import S from './ImageCapture.css'

function ImageCapture( props ) {
  const { 
    attr,
    eventData,
    target,
    value : pValue,
    delegate,
    onChange : pOnChange,
    disabled,
    allowDelete = true } = props

  const [ url, setUrl ] = useState()
  const [ shape, setShape ] = useState()
  const dispatch = useDispatch()
  const value = pValue?.value?.[0] || pValue
  
  const error = useSelector( ( state ) => {
    return UI.get( state, `imageError/${attr?.blueprint?.updatePath}` )
  } )

  useEffect( () => {
    setUrl( url )
  }, [] )

  useEffect( () => {
    setTimeout( () => {
      if ( value instanceof File ) {
        setUrl( URL.createObjectURL( value ) )
      } else if ( value && target?.id ) {
        const itemDelegate = delegate.item ? delegate.item( target.id ) : delegate
        dispatch( itemDelegate.resource( `resourceImage/${attr?.blueprint?.updatePath.slice( 5 )}` ).get() ).then( ( data ) => {
          const { data : { url } } = data
          setUrl( url )
        } )
      }
    }, 500 )
  }, [ value ] )

  // ===================================

  const [ isEditing, setIsEditing ] = useState( false )

  const onOpenImageCapture = () => {
    setIsEditing( true )
  }

  const onDeleteImage = () => {
    pOnChange( { data : 'defect.image', value : null } )
    
    setUrl( null )
  }
  
  const onCloseImgCapture = () => {
    setIsEditing( false )
  }
  
  const setFormImageAgainTho = ( file ) => {
    pOnChange( { data : 'defect.image', value : { value : [ file ], type : 'set' } } )
  }
  
  function timer( seconds ) {
    return new Promise( ( resolve ) => {
      setTimeout( resolve, seconds * 1000 )
    } )
  }

  const setFormImage = async ( newImg ) => {
    await timer( 1 )
    setUrl( newImg )
    const file = dataURLtoFile( newImg )
    pOnChange( { data : 'defect.image', value : { value : [ file ], type : 'set' } } )
    setFormImageAgainTho( file )
  }

  const setFormShape = ( newPointList ) => {
    const polygonCoords = [ ...newPointList, newPointList[0] ] // last needs to equal first to close the plygn
    const shapeObj = {
      type : 'polygon',
      coordinates : polygonCoords
    }
    pOnChange( { data : 'defect.shape', value : JSON.stringify( shapeObj ) } )
    setShape( JSON.stringify( shapeObj ) )
  }

  if ( isEditing ) {
    return (
      <PortalOverlay show={isEditing} position="full">
        <CameraScreen
          onClose={onCloseImgCapture}
          setFormImage={setFormImage}
          setFormShape={setFormShape} />
      </PortalOverlay>
    )
  }

  return (
    <Pane layout="flex:colS">
      {!url && <Button onClick={onOpenImageCapture} variant="uploadFile">Take Photo</Button>}
      {url && (
        <Flex align="flex-start" >
          <div className={S.imageContainer}>
            <img
              className={S.image}
              alt=""
              src={url} />
          </div>
          <Flex className={S.buttonContainer} align="stretch" variant="colM">
            <Button onClick={onOpenImageCapture} variant="secondarySmallLeftIcon">Retake</Button>
            <Button onClick={onDeleteImage} variant="dangerSmallLeftIcon">Delete</Button>
          </Flex>
        </Flex>
      )}
    </Pane>
  )
}

export default ImageCapture

function dataURLtoFile( dataurl, filename ) {
  const arr = dataurl.split( ',' )
  const mime = arr[0].match( /:(.*?);/ )[1]
  const bstr = atob( arr[arr.length - 1] )

  let n = bstr.length
  const u8arr = new Uint8Array( n )

  while ( n-- ) {
    u8arr[n] = bstr.charCodeAt( n )
  }
  return new File( [ u8arr ], filename, { type : mime } )
}
